import React from "react";
import cx from "clsx";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { SubscriptionCard } from "./shared/SubscriptionCard/SubscriptionCard";
import {
  CHARTSMART_PLAN,
  CHARTSMART_PLAN_WEIGHTS,
} from "../../../../consts/ChartSmart";
import { useSubscriptionDetailsQuery } from "../../../../api/chartSmart/useSubscriptionDetailsQuery";
import { OctagonAlertIcon } from "../../../../assets/Icons/OctagonAlertIcon";
import styles from "./сhartSmartSubscription.module.scss";
import { SUBSCRIPTION_ERROR } from "../../hooks/useDictation";
import { capitalize } from "../../../../utilities/general";

export function ChartSmartSubscriptions({
  selectedPlan,
  onSelectPlan,
  subscriptionError,
}) {
  const { tSettings } = useAppTranslation.Settings();
  const { tCommon } = useAppTranslation.Common();
  const { data } = useSubscriptionDetailsQuery();

  const currentPlanWeight = data?.chartSmartPlan
    ? CHARTSMART_PLAN_WEIGHTS[data.chartSmartPlan]
    : 0;

  const subscriptionCards = [
    {
      component: (
        <SubscriptionCard
          key={CHARTSMART_PLAN.payg}
          planName={CHARTSMART_PLAN.payg}
          onSelectPlan={onSelectPlan}
          selectedPlan={selectedPlan}
          subscriptionError={subscriptionError}
        />
      ),
      isVisible: subscriptionError !== SUBSCRIPTION_ERROR.planNotFound,
    },
    {
      component: (
        <SubscriptionCard
          key={CHARTSMART_PLAN.starter}
          planName={CHARTSMART_PLAN.starter}
          onSelectPlan={onSelectPlan}
          selectedPlan={selectedPlan}
          subscriptionError={subscriptionError}
        />
      ),
      isVisible: subscriptionError === SUBSCRIPTION_ERROR.planNotFound,
    },
    {
      component: (
        <SubscriptionCard
          key={CHARTSMART_PLAN.pro}
          planName={CHARTSMART_PLAN.pro}
          onSelectPlan={onSelectPlan}
          selectedPlan={selectedPlan}
          subscriptionError={subscriptionError}
        />
      ),
      isVisible:
        subscriptionError === SUBSCRIPTION_ERROR.planNotFound ||
        currentPlanWeight < CHARTSMART_PLAN_WEIGHTS[CHARTSMART_PLAN.pro],
    },
    {
      component: (
        <SubscriptionCard
          key={CHARTSMART_PLAN.unlimited}
          planName={CHARTSMART_PLAN.unlimited}
          onSelectPlan={onSelectPlan}
          selectedPlan={selectedPlan}
          subscriptionError={subscriptionError}
        />
      ),
      isVisible:
        subscriptionError === SUBSCRIPTION_ERROR.planNotFound ||
        currentPlanWeight < CHARTSMART_PLAN_WEIGHTS[CHARTSMART_PLAN.unlimited],
    },
  ].filter((card) => card.isVisible);

  return (
    <div className={styles.section}>
      {subscriptionError === SUBSCRIPTION_ERROR.limitReached && (
        <>
          <div className={cx(styles.currentPlan, styles.header)}>
            <span className={styles.alert}>
              <OctagonAlertIcon />
            </span>{" "}
            <span className={styles.title}>
              {tCommon("dictation.title.warning")}
            </span>
          </div>
          <div className={styles.disclaimer}>
            {tCommon("dictation.disclaimer.warning.p1")}
            <br />
            {tCommon("dictation.disclaimer.warning.p2")}
          </div>
        </>
      )}
      <div className={styles.currentPlan}>
        {tSettings("subscriptions.chartSmart.currentPlan")}
        <span className={styles.selected}>
          {data?.chartSmartPlan
            ? capitalize(data.chartSmartPlan)
            : tSettings("subscriptions.chartSmart.noPlan")}
        </span>
      </div>
      <div className={styles.cardsWrapper}>
        {subscriptionCards.map((card) => card.component)}
      </div>
    </div>
  );
}
